
      import OrderCancel from './order-cancel.vue'
      import type { App, Plugin } from 'vue'

      export const OrderCancelPlugin: Plugin = {
        install(app: App) {
          app.component('OrderCancel', OrderCancel)
        },
      }
      export { OrderCancel }
      